import { render, staticRenderFns } from "./PrometPoDistributerima.vue?vue&type=template&id=f23afac0&scoped=true&"
import script from "./PrometPoDistributerima.vue?vue&type=script&lang=ts&"
export * from "./PrometPoDistributerima.vue?vue&type=script&lang=ts&"
import style0 from "./PrometPoDistributerima.vue?vue&type=style&index=0&id=f23afac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23afac0",
  null
  
)

export default component.exports